/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Strength_LeadInputs */

const en_for_whom_strength_lead = /** @type {(inputs: For_Whom_Strength_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength and new bests.`)
};

const pl_for_whom_strength_lead = /** @type {(inputs: For_Whom_Strength_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siła i rekordy.`)
};

/**
* | output |
* | --- |
* | "Strength and new bests." |
*
* @param {For_Whom_Strength_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_strength_lead = /** @type {((inputs?: For_Whom_Strength_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Strength_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_strength_lead(inputs)
	return en_for_whom_strength_lead(inputs)
});